/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';
import template from './role-list-page.component.html';

import {AdminListColumn, AdminResourceListPageBase} from '../../common/controller/admin-resource-list-page-base';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';

@Component({
  standalone: false,
  selector: 'adn-role-list-page',
  template
})
export class RoleListPageComponent extends AdminResourceListPageBase {
  readonly itemStateName = 'app.adm.roles.role';

  columns: AdminListColumn[] = [
    {param: 'name'},
    {param: 'application'},
    {param: 'scope'},
    {param: 'description'}
  ];

  constructor(
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any
  ) {
    super(LocalNetworkProfile);
  }
}
